import { Directive, ElementRef, HostListener } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
@Directive({
    selector: '[octoScrollToInvalidControl]',
    standalone: false,
})
export class ScrollToInvalidControlDirective {
    constructor(
        private eleRef: ElementRef,
        private formGroupDir: FormGroupDirective
    ) {}

    @HostListener('ngSubmit') onSubmit() {
        if (this.formGroupDir.control.invalid) {
            this.scrollToFirstInvalidControl();
        }
    }

    getTopOffset(element: HTMLElement): number {
        const pageHeaderHeight = 197;
        let offset =
            element.getBoundingClientRect().top +
            window.scrollY -
            pageHeaderHeight;
        return offset;
    }

    scrollToFirstInvalidControl(): void {
        const firstInvalidControl =
            this.eleRef.nativeElement.querySelector('.ng-invalid');

        if (firstInvalidControl) {
            window.scroll({
                top: this.getTopOffset(firstInvalidControl),
                left: 0,
                behavior: 'smooth',
            });

            fromEvent(window, 'scroll')
                .pipe(debounceTime(100), take(1))
                .subscribe(() => firstInvalidControl.focus());
        }
    }
}
